import { animateScroll } from "../helpers/animate";

const showers = $('[data-show]');

const handleCLick = e => {
  const target = e.currentTarget;
  const elementToShow = $(target.dataset.show);
  if (elementToShow) {
    const hideTarget = target.dataset.showHide;
    const scrollToElement = target.dataset.showScroll;
    const headerOffset = $('.header').height();
    elementToShow.show();

    if (hideTarget) {
      target.style.display = 'none';
    }

    if (scrollToElement) {
      animateScroll(elementToShow, 400, elementToShow.offset().top - headerOffset);
    }
  }
}

showers.click(handleCLick);
